import React, {useState, useEffect, useRef} from 'react'
import API from '../../services/api'
import TableLoader from '../../shared/TableLoader'
import NoDataFound from '../../shared/NoDataFound'
import { SlIcon, SlTooltip } from '@shoelace-style/shoelace/dist/react'
import ScrollContainer from 'react-indiana-drag-scroll'
import config from '../../config'
import { debounce } from '../../utils/Debounce'
import Paginator from '../../shared/Paginator'
import { useNavigate } from 'react-router'
import { roles } from '../../utils/constants';
import { CSVLink } from "react-csv";
import { daysBetween, formatDateDDMMYYY} from '../../utils/dateFormat'

function AgingReport() {
    const navigate = useNavigate()
    const [agingReportData, setAgingReportData] = useState([])
    const [loader, setLoader] = useState(true)
    const [totalPages, setTotalPages] = useState(0)
    const [search, setSearch] = useState('')
    const [currentPage, setCurrentPage] = useState(0)
    const [downloadData, setDownloadData] = useState([])
    const [downloadLoader, setDownloadLoader] = useState(false)


    const fetchAgingReportData = async () =>{
        setLoader(true)
        try {
            let res = await API({
                url:'finance_panel/aging-reports',
                method:'POST',
                responseType:'json',
                data:{
                    search:search,
                    limit:config.PER_PAGE,
                    offset:currentPage
                }
            })
        if(res.code === 200){
            setAgingReportData(res.data?.data)
            setTotalPages(Math.ceil(res.data?.totalCounts / config.PER_PAGE));

        }
        } catch (error) {
            console.error(error)
        }
        finally{
            setLoader(false)
        }
    }
    const csvLinkRef = useRef(); // Create a ref for CSVLink
    let csvHeaders = [
      { label: "Customer Name", key: "company_name" },
      { label: "sales Person", key: "name" },
      { label: "Invoice Date", key: "invoice_date" },
      {label:"Due Date", key:"credited_period"},
      { label: "Invoice Number", key: "invoice_no" },
      { label: "Total Amount", key: "amount" },
      { label: "Payment", key: "total_payment" },
      {label:"No Due", key:"nodue"},
      {label:"30", key:"30"},
      {label:"90", key:"90"},
      {label:"180", key:"180"},
      {label:">180", key:">180"},
  ];

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
      };
      const downloadReport = async (
      ) => {
          setDownloadLoader(true);
          try {
        let result = await API({
            url: "/finance_panel/aging-reports-download",
            method: "POST",
            responseType: "json",
            data: {
              search:search
            },
        });
        if (result?.code === 200) {
            setDownloadLoader(false);
            setDownloadData(result.data);
        }
          } catch (error) {
        setDownloadLoader(false);
        console.error(error);
        if (error.response.status === 401) navigate("/");
          }
      };
      useEffect(() => {
        if (downloadData.length) {
            csvLinkRef?.current?.link?.click();
            setDownloadData([]);
        }
      }, [downloadData]);

    useEffect(() =>{
        fetchAgingReportData()
    }, [search, currentPage])

    function daysBetween(timestamp) {
      // Convert 10-digit timestamp to milliseconds and create a Date object
      const startDate = new Date(timestamp * 1000);
      
      // Get today's date
      const endDate = new Date();
      
      // Check if startDate is valid
      if (isNaN(startDate.getTime())) {
          throw new Error("Invalid timestamp");
      }
  
      const millisecondsPerDay = 86400000; // 24 * 60 * 60 * 1000
      
      // Calculate the difference in days
      return Math.floor((endDate - startDate) / millisecondsPerDay);
  }
  
  
  return (
    <>
        <h5>Aging Report</h5>
        <div className='d-flex  gap-3 flex-wrap justify-end ml-auto mb-2 items-center'>
        <input type="text" className='form-control max-w-[280px]' placeholder='Invoice / Customer / Sales' onChange={
            debounce((e) => setSearch(e.target.value), 500)}/>
        {( localStorage.getItem('role') === roles.financer) &&<div >
          <CSVLink
              data={downloadData.map(
                  ({company_name,
                    name,
                    invoice_amount,
                    total_payment,
                    invoice_date,
                    credited_period,
                    invoice_no,
                    due_amount
                  }) => {
                    const days = due_amount <= 0 ? - 1: daysBetween(credited_period);
                     due_amount = due_amount <= 0 ? 0 : due_amount;

                    let obj = {
                      name,
                      company_name,
                      invoice_date:formatDateDDMMYYY(invoice_date),
                      invoice_no,
                      amount: invoice_amount,
                      total_payment,
                      nodue: days <= 0 ? due_amount : '',
                      '30': 0 <= days && days <= 30 ? due_amount : '',
                      '90': days <= 90 && days > 30 ? due_amount : '',
                      '180': days <= 180 && days > 90 ? due_amount : '',
                      ">180": days > 180 ? due_amount : '',
                    };
  
                    return obj;
                  }              )}
              headers={csvHeaders}
              filename={"aging_report.csv"}
              ref={csvLinkRef} // Assign the ref to the CSVLink component
          ></CSVLink>

          {downloadLoader ? (
              <TableLoader />
          ) : (
              <SlTooltip content="Export">
                  <SlIcon
                      library="lucide"
                      name="download"
                      className="w-6 h-6 cursor-default hover:text-sky-300 mr-1"
                      onClick={() => {
                          downloadReport(search)
                      }}
                  ></SlIcon>
              </SlTooltip>
          )}
        </div>}
        </div>
        <ScrollContainer>
        <table className='table table-bordered'>
            <thead>
                <tr>
                    <th>Customer</th>
                    <th>Sales Person</th>
                    <th>Invoice Number</th>
                    <th>Invoice Date</th>
                    <th>Due Date</th>
                    <th>Not at Due</th>
                    <th>30</th>
                    <th>90</th>
                    <th>180</th>
                    <th>{'>180'}</th>
                </tr>
                </thead>
            {
                !loader && agingReportData.length > 0 ? <tbody>
                    {
                        agingReportData.map((item, index) => {
                          // Calculate days between invoice_date and today
                          const days = item.due_amount <= 0 ? - 1: daysBetween(item.credited_period);
                          let due_amount = item.due_amount <= 0 ? 0 : item.due_amount;
                          return (
                              <tr key={index}>
                                  <td>{item.company_name}</td>
                                  <td>{item.name}</td>
                                  <td>{item.invoice_no}</td>
                                  <td>{formatDateDDMMYYY(item.invoice_date)}</td>
                                  <td>{formatDateDDMMYYY(item.credited_period)}</td>
                                  <td>{days < 0 ? due_amount : ''}</td>
                                  <td>{0 <= days && days <= 30 ? due_amount : ''}</td>
                                  <td>{days >= 31 && days <= 90 ? due_amount : ''}</td>
                                  <td>{days >= 91 && days <= 180 ? due_amount : ''}</td>
                                  <td>{days > 180 ? due_amount : ''}</td>
                              </tr>
                          );
                      })
                    }
                </tbody> : loader ? <TableLoader colspan={7}/> : <NoDataFound colspan={7}/>
            }
            </table>
            </ScrollContainer>
            <div className="flex justify-end">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
    </>
  )
}

export default AgingReport